import { SupplierEdit } from '@client/components/suppliers/SupplierEdit';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New supplier',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const orgId = useOrgId();
    const { id } = Route.useParams();
    const navigate = useNavigate();
    const isReadonly = claimFormStore.use.isReadonly();

    // CUR-725: closed claims are read-only — no new suppliers from a closed claim.
    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return (
        <SupplierEdit
            onSuccess={(supplier) =>
                navigate({
                    to: '/console/$orgId/claims/details/$id/manage/supplier-jobs/add',
                    params: { orgId, id },
                    search: {
                        newSupplierId: supplier.supplierId.toString(),
                        newSupplierEmail: supplier.email,
                        newSupplierPhone: supplier.phone,
                    },
                })
            }
        />
    );
}
